const MaintenanceView = ({ setView }) => (
  <div style={{ maxWidth: 520, margin: "120px auto", padding: "0 24px", textAlign: "center" }} className="fade-up">
    <p style={{ fontFamily: "var(--font-mono)", fontSize: "11px", letterSpacing: "0.15em", color: "var(--amber)", textTransform: "uppercase", marginBottom: 16 }}>Maintenance Mode</p>
    <h1 style={{ fontSize: "42px", marginBottom: 16 }}>We'll be back soon.</h1>
    <p style={{ color: "var(--text-dim)", fontSize: "15px", lineHeight: 1.7 }}>
      The store is temporarily offline for scheduled maintenance. Please check back shortly.
    </p>
    <button onClick={() => setView("auth")} style={{ marginTop: 24, background: "none", border: "none", color: "var(--text-muted)", fontFamily: "var(--font-mono)", fontSize: "11px", cursor: "pointer", textDecoration: "underline" }}>
      Admin sign in
    </button>
  </div>
);

export default MaintenanceView;
